import styled from 'styled-components';
import { motion } from 'framer-motion';

const Wrapper = styled.div`
  display: inline-block;
`;

const CardWrapper = styled(motion.div)`
  position: absolute;
  width: 220px;
  top: calc(100% + ${(props) => props.theme.space[2]}px);
  right: 0;
  cursor: auto;
`;

export { Wrapper, CardWrapper };
